import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import type { TopEarner } from '../../types/dashboard.types';

interface TopEarnersChartProps {
  data: TopEarner[];
}

export const TopEarnersChart: React.FC<TopEarnersChartProps> = ({ data }) => {
  if (!data || data.length === 0) {
    return (
      <div className="bg-white rounded-lg shadow p-6">
        <h3 className="text-lg font-semibold mb-4 text-gray-900">Top Earners</h3>
        <div className="h-[300px] flex items-center justify-center text-gray-500">
          No earner data available
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h3 className="text-lg font-semibold mb-4 text-gray-900">Top Earners</h3>
      <ResponsiveContainer width="100%" height={300}>
        <BarChart data={data} layout="vertical">
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            type="number"
            tick={{ fontSize: 12 }}
            tickFormatter={(value) => `$${value.toLocaleString()}`}
          />
          <YAxis dataKey="agentName" type="category" tick={{ fontSize: 12 }} width={120} />
          <Tooltip formatter={(value: any) => `$${Number(value).toLocaleString()}`} />
          <Legend />
          <Bar dataKey="totalCommission" fill="#10b981" name="Total Commission" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};
